// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gc-auth-footer {
  position: absolute;
  left: 0;
  bottom: 0px;
  text-align: center;
  width: 100%;
}
.gc-auth-footer p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #1F2937;
}`, "",{"version":3,"sources":["webpack://./src/app/core/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;AACJ;AAAI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAEN","sourcesContent":[".gc-auth-footer{\n    position: absolute;\n    left: 0;\n    bottom: 0px;\n    text-align: center;\n    width: 100%;\n    p{\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 30px;\n      text-align: center;\n      color: #1F2937;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
